customElements.get("quick-add-modal")||customElements.define("quick-add-modal",class extends ModalDialog{constructor(){super(),this.modalContent=this.querySelector('[id^="QuickAddInfo-"]')}hide(preventFocus=!1){const cartNotification=document.querySelector("cart-notification")||document.querySelector("cart-drawer");cartNotification&&cartNotification.setActiveElement(this.openedBy),this.stopDesktopPopup(),this.modalContent.innerHTML="",preventFocus&&(this.openedBy=null),super.hide()}show(opener){opener.setAttribute("aria-disabled",!0),opener.classList.add("loading"),opener.querySelector(".loading__spinner").classList.remove("hidden"),fetch(opener.getAttribute("data-product-url")).then(response=>response.text()).then(responseText=>{const responseHTML=new DOMParser().parseFromString(responseText,"text/html");this.productElement=responseHTML.querySelector('section[id^="MainProduct-"]'),this.productElement.classList.forEach(classApplied=>{(classApplied.startsWith("color-")||classApplied==="gradient")&&this.modalContent.classList.add(classApplied)}),this.preventDuplicatedIDs(),this.removeDOMElements(),this.prepareDesktopPopup(opener),this.setInnerHTML(this.modalContent,this.productElement.innerHTML),window.Shopify&&Shopify.PaymentButton&&Shopify.PaymentButton.init(),window.ProductModel&&window.ProductModel.loadShopifyXR(),this.removeGalleryListSemantic(),this.updateImageSizes(),this.preventVariantURLSwitching(),super.show(opener),this.startDesktopPopup()}).finally(()=>{opener.removeAttribute("aria-disabled"),opener.classList.remove("loading"),opener.querySelector(".loading__spinner").classList.add("hidden")})}setInnerHTML(element,html){
  const registry = window.mvQuickAddScriptRegistry || (window.mvQuickAddScriptRegistry = { theme: new Set(), affirm: new Set() });
  const themeKey = script => {
    if (!script.src) return null;
    const url = new URL(script.src, document.baseURI);
    return url.origin === location.origin && /\/assets\/(?:product-form|product-info|product-model|show-more|price-per-item|magnify|quick-add)(?:\.aio\.min)?\.js$/.test(url.pathname) ? url.href : null;
  };
  const affirmKey = script => !script.src && script.closest('[id*="affirm_pay_over_time_messaging"]')
    && /\bconst\s+appData\s*=/.test(script.textContent) && script.textContent.includes('promoAppConfig')
    ? script.textContent.trim() : null;
  // Remember existing page-level dependencies before inserting the fetched nodes.
  document.querySelectorAll('script').forEach(script => {
    const theme = themeKey(script), affirm = affirmKey(script);
    if (theme) registry.theme.add(theme);
    if (affirm) registry.affirm.add(affirm);
  });
  element.innerHTML = html;
  element.querySelectorAll('script').forEach(oldScriptTag => {
    const type = (oldScriptTag.type || '').toLowerCase();
    if (type && !['text/javascript','application/javascript','module'].includes(type)) return;
    const theme = themeKey(oldScriptTag), affirm = affirmKey(oldScriptTag);
    if ((theme && registry.theme.has(theme)) || (affirm && registry.affirm.has(affirm))) {
      oldScriptTag.remove();
      return;
    }
    const newScriptTag = document.createElement('script');
    Array.from(oldScriptTag.attributes).forEach(attribute => newScriptTag.setAttribute(attribute.name,attribute.value));
    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
    if (theme) {
      registry.theme.add(theme);
      newScriptTag.addEventListener('error', () => registry.theme.delete(theme), {once:true});
    }
    if (affirm) registry.affirm.add(affirm);
    oldScriptTag.parentNode.replaceChild(newScriptTag,oldScriptTag);
  });
}

  prepareDesktopPopup(opener) {
    this.classList.toggle('mv-quick-add', window.matchMedia('(min-width: 750px)').matches);
    if (!this.classList.contains('mv-quick-add')) return;
    const info = this.productElement.querySelector('product-info');
    if (!info) return;
    this.productElement.querySelector('.breadcrumbs')?.remove();
    info.querySelectorAll('.invx-product-gallery').forEach(gallery => gallery.remove());
    const gallery = this.productElement.querySelector('.invx-lg-product-gallery mv-product-gallery');
    gallery?.querySelectorAll('.mySwiperSmall .swiper-slide').forEach((thumb, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mv-qa-thumb-button';
      button.dataset.mvQaImage = String(index);
      button.setAttribute('aria-label', 'View product image ' + (index + 1));
      button.append(...thumb.childNodes);
      thumb.append(button);
    });
    const quantity = info.querySelector('.product-form__quantity');
    const purchase = info.querySelector('.product__purchase-area');
    if (quantity && purchase) purchase.prepend(quantity);
    const price = info.querySelector('.invx-custom-price-layout');
    const deadline = info.querySelector('.product__sale-deadline');
    if (price) {
      const group = document.createElement('div');
      group.className = 'mv-qa-price-group';
      price.before(group);
      group.append(price);
      if (deadline) group.append(deadline);
    }
    const card = opener.closest('.card-wrapper, .product-card-wrapper');
    const stars = card && card.querySelector('.rating');
    const count = card && card.querySelector('.rating-count');
    const yotpo = info.querySelector('[id*="yotpo_product_photo_reviews_star_rating"]');
    if (stars && count && yotpo) {
      const rating = document.createElement('div');
      rating.className = 'mv-qa-rating';
      const starCopy = stars.cloneNode(true);
      const countCopy = document.createElement('span');
      countCopy.className = 'mv-qa-rating-count';
      countCopy.textContent = (count.querySelector('[aria-hidden="true"]') || count).textContent.trim();
      const total = Number(countCopy.textContent.replace(/[^0-9]/g, ''));
      if (!total) starCopy.setAttribute('aria-label', 'No published reviews');
      countCopy.setAttribute('aria-label', total + (total === 1 ? ' review' : ' reviews'));
      rating.append(starCopy, countCopy);
      yotpo.replaceWith(rating);
    }
    this.quickAddAffirmConfig = null;
    const affirmBlock = info.querySelector('[id*="affirm_pay_over_time_messaging"]');
    if (affirmBlock) {
      affirmBlock.classList.add('mv-qa-affirm');
      for (const script of affirmBlock.querySelectorAll('script')) {
        const match = script.textContent.match(/JSON\.parse\('([^']+)'\)/);
        if (!match) continue;
        try { this.quickAddAffirmConfig = JSON.parse(match[1]); } catch (error) { /* Provider configuration is optional. */ }
      }
    }
  }
  startDesktopPopup() {
    if (!this.classList.contains('mv-quick-add')) return;
    this.startPopupPriceAlignment();
    const gallery = this.modalContent.querySelector('mv-product-gallery');
    if (gallery) {
      this.quickAddThumbGallery = gallery;
      this.quickAddThumbClick = event => {
        const button = event.target.closest('.mv-qa-thumb-button');
        const slider = gallery.querySelector('.mySwiperMain')?.swiper;
        if (!button || !slider || slider.destroyed) return;
        const index = Number(button.dataset.mvQaImage);
        event.preventDefault();
        event.stopPropagation();
        if (slider.params.loop) slider.slideToLoop(index);
        else slider.slideTo(index);
      };
      gallery.addEventListener('click', this.quickAddThumbClick, true);
    }
    const span = this.modalContent.querySelector('.affirm-as-low-as');
    if (!span) return;
    const key = this.quickAddAffirmConfig?.region_public_keys?.ca;
    if (!window.affirm?.ui?.ready && key) {
      window._affirm_config = {
        public_api_key: key,
        script: 'https://cdn1.affirm.com/js/v2/affirm.js',
        locale: document.documentElement.lang.startsWith('fr') ? 'fr_CA' : 'en_CA',
        country_code: 'CAN'
      };
      (function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,'set');var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c='set add save post open empty reset on off trigger ready setProduct'.split(' ');a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=['get','token','url','items'];a<c.length;a++)f[c[a]]=function(){};k.async=!0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,window._affirm_config,'affirm','checkout','ui','script','ready','jsReady');
    }
    const refresh = () => {
      if (!this.hasAttribute('open') || !span.isConnected) return;
      const ui = window.affirm?.ui;
      if (typeof ui?.components?.render === 'function') {
        span.id = this.id + '-affirm';
        ui.components.render('#' + span.id);
      } else if (typeof ui?.refresh === 'function') ui.refresh();
    };
    if (typeof window.affirm?.ui?.ready === 'function') window.affirm.ui.ready(refresh);
    const purchase = this.modalContent.querySelector('.product__purchase-area');
    const selectors = this.modalContent.querySelector('variant-selects');
    let variants = [];
    try { variants = JSON.parse(selectors?.querySelector('script[type="application/json"]')?.textContent || '[]'); } catch (error) { /* Retain the native provider metadata. */ }
    const syncAmount = () => {
      const terms = purchase?.querySelector('shopify-payment-terms');
      const options = Array.from(selectors?.querySelectorAll('select') || []).map(select => select.value);
      const selected = variants.find(variant => variant.options.length === options.length && variant.options.every((value, index) => value === options[index]));
      try {
        if (selected && terms && terms.getAttribute('variant-id') !== String(selected.id)) terms.setAttribute('variant-id', String(selected.id));
        const metadata = JSON.parse(terms?.getAttribute('shopify-meta') || '{}');
        const stored = metadata.variants?.find(item => String(item.id) === terms?.getAttribute('variant-id'));
        const amount = selected ? Number(selected.price) : Math.round(Number(stored?.full_price_amount) * 100);
        if (!Number.isFinite(amount) || amount <= 0 || span.getAttribute('data-amount') === String(amount)) return;
        span.setAttribute('data-amount', String(amount));
        if (typeof window.affirm?.ui?.ready === 'function') window.affirm.ui.ready(refresh);
      } catch (error) { /* Keep the provider's existing amount if metadata is unavailable. */ }
    };
    if (selectors) {
      this.quickAddVariantSelectors = selectors;
      this.quickAddVariantChanged = syncAmount;
      selectors.addEventListener('change', syncAmount);
    }
    if (purchase) {
      this.quickAddAffirmObserver = new MutationObserver(syncAmount);
      this.quickAddAffirmObserver.observe(purchase, {subtree: true, childList: true, attributes: true, attributeFilter: ['variant-id', 'shopify-meta']});
      syncAmount();
    }
  }
  startPopupPriceAlignment() {
    const group = this.modalContent.querySelector('.mv-qa-price-group');
    if (!group) return;
    const syncWidth = () => {
      const amount = group.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item--regular');
      if (!amount) return;
      const width = amount.getBoundingClientRect().width;
      group.style.setProperty('--mv-qa-price-width', width + 'px');
      const deadline = group.querySelector('.product__sale-deadline');
      if (deadline && width > 0) {
        group.style.setProperty('--mv-qa-deadline-font-size', '12px');
        const naturalWidth = deadline.getBoundingClientRect().width;
        if (naturalWidth > 0) group.style.setProperty('--mv-qa-deadline-font-size', (12 * width / naturalWidth) + 'px');
      }
    };
    this.quickAddPriceResize = new ResizeObserver(syncWidth);
    const watchAmount = () => {
      this.quickAddPriceResize.disconnect();
      const amount = group.querySelector('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item--regular');
      if (amount) this.quickAddPriceResize.observe(amount);
      syncWidth();
    };
    this.quickAddPriceMutations = new MutationObserver(watchAmount);
    this.quickAddPriceMutations.observe(group, {subtree:true, childList:true});
    watchAmount();
  }
  stopDesktopPopup() {
    this.quickAddVariantSelectors?.removeEventListener('change', this.quickAddVariantChanged);
    this.quickAddVariantSelectors = null;
    this.quickAddVariantChanged = null;
    this.quickAddThumbGallery?.removeEventListener('click', this.quickAddThumbClick, true);
    this.quickAddThumbGallery = null;
    this.quickAddThumbClick = null;
    this.quickAddPriceResize?.disconnect();
    this.quickAddPriceMutations?.disconnect();
    this.quickAddPriceResize = null;
    this.quickAddPriceMutations = null;
    this.quickAddAffirmObserver?.disconnect();
    this.quickAddAffirmObserver = null;
  }
preventVariantURLSwitching(){const variantPicker=this.modalContent.querySelector("variant-radios,variant-selects");variantPicker&&variantPicker.setAttribute("data-update-url","false")}removeDOMElements(){const pickupAvailability=this.productElement.querySelector("pickup-availability");pickupAvailability&&pickupAvailability.remove();const productModal=this.productElement.querySelector("product-modal");productModal&&productModal.remove();const modalDialog=this.productElement.querySelectorAll("modal-dialog");modalDialog&&modalDialog.forEach(modal=>modal.remove())}preventDuplicatedIDs(){const sectionId=this.productElement.dataset.section;this.productElement.innerHTML=this.productElement.innerHTML.replaceAll(sectionId,`quickadd-${sectionId}`),this.productElement.querySelectorAll("variant-selects, variant-radios, product-info").forEach(element=>{element.dataset.originalSection=sectionId})}removeGalleryListSemantic(){const galleryList=this.modalContent.querySelector('[id^="Slider-Gallery"]');galleryList&&(galleryList.setAttribute("role","presentation"),galleryList.querySelectorAll('[id^="Slide-"]').forEach(li=>li.setAttribute("role","presentation")))}updateImageSizes(){const product=this.modalContent.querySelector(".product");if(!product.classList.contains("product--columns"))return;const mediaImages=product.querySelectorAll(".product__media img");if(!mediaImages.length)return;let mediaImageSizes="(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";product.classList.contains("product--medium")?mediaImageSizes=mediaImageSizes.replace("715px","605px"):product.classList.contains("product--small")&&(mediaImageSizes=mediaImageSizes.replace("715px","495px")),mediaImages.forEach(img=>img.setAttribute("sizes",mediaImageSizes))}});
//# sourceMappingURL=/s/files/1/0558/6780/1757/t/19/assets/quick-add.js.map?v=1725103455
